import { FeatureInfoControl } from "../controls/FeatureInfoControl";

export function addFeatureInfoControl(map) {
  const featureInfoControl = new FeatureInfoControl();
  map.addControl(featureInfoControl);
  map.on("singleclick", function () {
    const allHoverLayers = featureInfoControl.getAllHoverLayers();
    allHoverLayers.forEach((hoverLayer) => hoverLayer.getSource().clear());
    featureInfoControl.unset("selectedFeaturesAndLayers");
  });
  map.on("pointermove", function (e) {
    const featuresAtPixel = [];
    if (e.originalEvent.target.tagName !== "CANVAS") {
      return;
    }
    const allHoverLayers = featureInfoControl.getAllHoverLayers();
    map.forEachFeatureAtPixel(
      e.pixel,
      (feature, layer) => {
        if (feature.get("nonInteractive")) return;
        featuresAtPixel.push({ feature: feature, layer: layer });
      },
      {
        layerFilter: (layer) => !allHoverLayers.includes(layer),
      },
    );
    featureInfoControl.setProperties({
      selectedFeaturesAndLayers: featuresAtPixel,
      position: e.coordinate,
    });
  });
  return featureInfoControl;
}
